export const tourDatas = [
    {
        id: 1,
        name: "Best of Taj Mahal in 2 days tour",
        info: "The Taj Mahal is one of the world's most recognizable structures. The UNESCO heritage site is considered one of the New Seven Wonders of the World — alongside the Great Wall of China and Petra in Jordan. But the Taj Mahal is one of the newer World Wonders on the list, having been commissioned in 1632. For this reason, its admirers are often surprised to find out that nobody actually knows who designed it.",
        image: 'https://discovery.sndimg.com/content/dam/images/discovery/fullset/2020/2/21/thumbnail.png.rend.hgtvcom.1280.960.suffix/1582329440048.png',
        price: '9999',
    },
    {
        id: 2,
        name: "The Breath-taking Architecture In The Ancient City Of Petra",
        info: "Petra is surrounded by mountains with passageways and canyons and is half-built, half-carved into the rock.The capital city of the Nabateans, situated between the Red Sea and the Dead Sea and inhabited since prehistoric times, became a major caravan center for Arabian incense, Chinese silks, and Indian spices during Hellenistic and Roman times, a crossroads between Arabia, Egypt, and Syria-Phoenicia.",
        image: 'https://www.practically.com/web/assets/blog/108/banner.jpeg',
        price: '25999',
    },
    {
        id: 3,
        name: "Great Wall of China",
        info: "The Great Wall of China is one of the most notorious structures in the entire world. The Jinshanling section in Hebei Province, China, pictured here, is only a small part of the wall that stretches over 4,000 kilometers (2,500 miles).",
        image: 'https://images.nationalgeographic.org/image/upload/t_edhub_resource_key_image/v1638892506/EducationHub/photos/the-great-wall-of-china.jpg',
        price: '22999',
    },
    {
        id: 4,
        name: "Andaman and Nicobar Islands",
        info: "Dotted with numerous pristine beaches, crystal clear water bodies and vibrant coral reefs, the Andamans are a beautiful string of islands on the Bay of Bengal. The Cellular Jail is a star tourist attraction here.",
        image: 'https://cdn.britannica.com/28/1628-050-50922A3F/Andaman-redwood-trees-Cinque-Islands-Rutland-Island.jpg',
        price: '15999',
    },
    {
        id: 5,
        name: "Ooty",
        info: "Officially called Ootacamund, the hill-town is better known by its nickname–Ooty. It is loved by Bollywood directors, honeymooners, families, and even backpackers, for its mountains, lakes, gardens, and waterfalls.",
        image: 'https://www.trawell.in/blog/wp-content/uploads/2024/03/ooty-main-730x410.jpg',
        price: '9999',
    },
    {
        id: 6,
        name: "Kashmir",
        info: "Located on the banks of the Jhelum river, Kashmir is a beautiful valley in the heart of the Himalayas. The most visited places here include Pahalgam, Gulmarg and Srinagar.",
        image: 'https://www.50plusvoyagers.com/grouptour/images/Kashmir/Kashmir-Senior-Citizen-Tour1.jpg',
        price: '14999',
    }
]